export default __webpack_public_path__ + "static/media/2.37511d26.jpg";